module.exports = __webpack_public_path__ + "slide-image.png?703be11c0705efad1fddc8d0f2336120";